import {
    CREATE_SIMPLE_INVOICE,
    DELETE_INVOICE,
    GET_ALL_INVOICES,
    SET_ALL_INVOICES,
    SET_CREATED_SIMPLE_INVOICE,
    SET_SIMPLE_INVOICE_DATA,
    SET_EDIT_INVOICE_DATA,
    GET_SINGLE_INVOICE,
    DOWNLOAD_INVOICE_CSV,
    DOWNLOAD_INVOICE_CSV_SUCCESS,
    DOWNLOAD_INVOICE_CSV_FAILURE
} from './actionTypes';

export const getAllInvoices = data => {
    return {
        payload: data,
        type: GET_ALL_INVOICES
    };
};
export const setAllInvoices = data => {
    return {
        payload: data,
        type: SET_ALL_INVOICES
    };
};

export const setSimpleInvoiceData = data => {
    return {
        payload: data,
        type: SET_SIMPLE_INVOICE_DATA
    };
};
export const createSimpleInvoice = data => {
    return {
        payload: data,
        type: CREATE_SIMPLE_INVOICE
    };
};
export const setCreatedSimpleInvoice = data => {
    return {
        payload: data,
        type: SET_CREATED_SIMPLE_INVOICE
    };
};
export const deleteInvoice = data => {
    return {
        payload: data,
        type: DELETE_INVOICE
    };
};

export const setEditInoiveData = data => {
    return {
        payload: data,
        type: SET_EDIT_INVOICE_DATA
    };
};

export const getInvoicesById = (data) => {
    return {
        payload: data,
        type: GET_SINGLE_INVOICE
    }
}

export const downloadInvoiceCsv = (data) => {
    return {
        payload: data,
        type: DOWNLOAD_INVOICE_CSV
    }
}

export const downloadInvoiceCsvSuccess = (data) => {
    return {
        payload: data,
        type: DOWNLOAD_INVOICE_CSV_SUCCESS
    }
}

export const downloadInvoiceCsvFailure = (data) => {
    return {
        payload: data,
        type: DOWNLOAD_INVOICE_CSV_FAILURE
    }
}

